import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { IOffer, IReward, ITier } from "redux/reducers/models/loyalty";

interface ILoyaltyStep1 {
    name: string;
    type: "points_based" | "tier_based" | "cash_back";
    welcome_text?: string;
}

interface ILoyaltyStep2 {
    offers: Array<Partial<IOffer>>;
}

interface ILoyaltyStep3 {
    rewards?: Array<Partial<IReward>>;
    tiers?: Array<Partial<ITier>>;
}

interface IPutLoyaltyProgram {
    name?: string;
    type?: "points_based" | "tier_based" | "cash_back";
    terms?: string;
    welcome_text?: string;
    automatic_enrolment?: number;
    enrolment_customer_types?: Array<number>;
    all_purchase_types_qualify?: number;
    exclude_discounted_items?: number;
    excluded_departments_ids?: Array<number>;
    offers?: Array<Partial<IOffer>>;
    rewards?: Array<Partial<IReward & {product_type_ids?: Array<number>; product_ids?: Array<number>}>>;
    tiers?: Array<Partial<ITier>>;
}

export async function GetLoyaltyProgram(useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty"), null, useGlobalLoader, cancelToken);
  }

  export async function GetLoyaltyProgramOffers(useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet<IOffer[]>(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/offers"), null, useGlobalLoader, cancelToken);
  }

  export async function GetLoyaltyProgramRewards(useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet<Array<IReward>>(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/rewards"), null, useGlobalLoader, cancelToken);
  }

  export async function GetLoyaltyProgramTiers(useGlobalLoader: boolean, cancelToken?: CancelToken) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/tiers"), null, useGlobalLoader, cancelToken);
  }

  export async function PostLoyaltyProgramStep1(params: ILoyaltyStep1, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/step1"), params, useGlobalLoader);
  }

  export async function PostLoyaltyProgramStep2(params: ILoyaltyStep2, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/step2"), params, useGlobalLoader);
  }

  export async function PostLoyaltyProgramStep3(params: ILoyaltyStep3, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/step3"), params, useGlobalLoader);
  }

  export async function PostDuplicateLoyaltyProgramOffer(params: {id: number}, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/offers"), params, useGlobalLoader);
  }

  export async function PostDuplicateLoyaltyProgramReward(params: {id: number}, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/rewards"), params, useGlobalLoader);
  }

  export async function PostDuplicateLoyaltyProgramTier(params: {id: number}, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/tiers"), params, useGlobalLoader);
  }

  export async function PutLoyaltyProgram(params: IPutLoyaltyProgram, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty"), params, useGlobalLoader);
  }

  export async function DeleteLoyaltyProgramOffer(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/offers"), params, useGlobalLoader);
  }

  export async function DeleteLoyaltyProgramReward(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/rewards"), params, useGlobalLoader);
  }

  export async function DeleteLoyaltyProgramTier(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/customer/loyalty/tiers"), params, useGlobalLoader);
  }
